import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Ship } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    const finish = async () => {
      if (!sessionId) { navigate("/login", { replace: true }); return; }
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser(data);
        const ticket = sessionStorage.getItem("fb_link_ticket");
        if (ticket) {
          try { await api.post("/auth/facebook/link", { ticket }); } catch { /* ignoré */ }
          sessionStorage.removeItem("fb_link_ticket");
        }
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    };
    finish();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-primary text-white">
      <div className="flex flex-col items-center gap-3">
        <Ship className="h-8 w-8 animate-pulse text-accent" />
        <p className="font-heading">Connexion en cours…</p>
      </div>
    </div>
  );
}
